import { useQsFilters } from "@dash/filters";

import { NotificationFilters, notificationFiltersSerializer } from "@megaron/megarax-uri";

export type Filters = NotificationFilters;

export const useNotificationsFilters = () => {
  const defaultFilters: Filters = {
    page: 0,
    startDate: undefined,
    endDate: undefined,
    app: undefined,
  };

  const { filters, setFilters } = useQsFilters(notificationFiltersSerializer, defaultFilters);

  const setFilter =
    <Tkey extends keyof Filters>(key: Tkey) =>
    (value: Filters[Tkey]) => {
      setFilters({ ...filters, [key]: value });
    };

  return { filters, setFilter, defaultFilters, setFilters };
};
